import { sessionUserSchema } from '@oefy/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { KeyRound, Unlink } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '../lib/api';
import { ButtonLink } from '../ui/button';
import { Spinner } from '../ui/spinner';
import { StatusScreen } from '../ui/status-screen';
import { sessionQueryKey } from './session';

function takeToken(): string {
  const token = window.location.hash.replace(/^#/, '');
  if (token !== '') {
    window.history.replaceState(window.history.state, '', window.location.pathname);
  }
  return token;
}

export function LinkPage() {
  const [token] = useState(takeToken);
  const started = useRef(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const signIn = useMutation({
    mutationFn: () => api.post('/auth/link', { token }, sessionUserSchema),
    onSuccess: (user) => {
      queryClient.setQueryData(sessionQueryKey, user);
      void navigate('/', { replace: true });
    },
  });

  useEffect(() => {
    if (started.current || token === '') {
      return;
    }
    started.current = true;
    signIn.mutate();
  }, [signIn, token]);

  if (token !== '' && !signIn.isError) {
    return (
      <StatusScreen icon={<Spinner />} pose="wave" title="Even geduld, je wordt ingelogd">
        Welkom bij Oefy! We zetten alles voor je klaar.
      </StatusScreen>
    );
  }

  return (
    <StatusScreen
      icon={<Unlink aria-hidden="true" />}
      tone="warning"
      title="Deze inloglink werkt niet meer"
      actions={
        <ButtonLink to="/inloggen">
          <KeyRound aria-hidden="true" />
          Inloggen met een code
        </ButtonLink>
      }
    >
      Een inloglink werkt één keer en is 7 dagen geldig. Log in met je e-mailadres; je krijgt dan
      meteen een code.
    </StatusScreen>
  );
}
